import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/logo-bottom.png';
const _withScopeId = n => (_pushScopeId("data-v-6e2844d1"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "top"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_3 = {
  class: "right"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "info"
}, " 公司地址：中国（四川）自由贸易试验区成都高新区锦城大道666号4栋8层2号 ", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bottom"
}, [/*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("a", {
  href: "https://beian.miit.gov.cn/"
}, "ICP备案号：蜀ICP备16014299号-1")]), /*#__PURE__*/_createElementVNode("p", null, "成都颂佳科技有限公司")], -1));
export function render(_ctx, _cache) {
  const _component_router_link = _resolveComponent("router-link");
  return _openBlock(), _createElementBlock("footer", null, [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createVNode(_component_router_link, {
    to: "/privacyAI"
  }, {
    default: _withCtx(() => [_createTextVNode("AI小画家隐私政策")]),
    _: 1
  }), _createVNode(_component_router_link, {
    to: "/dispute"
  }, {
    default: _withCtx(() => [_createTextVNode("纠纷处理")]),
    _: 1
  }), _createVNode(_component_router_link, {
    to: "/privacy"
  }, {
    default: _withCtx(() => [_createTextVNode("隐私政策")]),
    _: 1
  }), _createVNode(_component_router_link, {
    to: "/agreement"
  }, {
    default: _withCtx(() => [_createTextVNode("用户协议")]),
    _: 1
  }), _createVNode(_component_router_link, {
    to: "/minority"
  }, {
    default: _withCtx(() => [_createTextVNode("未成年人隐私政策保护")]),
    _: 1
  })])]), _hoisted_4, _hoisted_5]);
}